/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import r from "prop-types";
const s = class s extends n.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
};
s.propTypes = {
  text: r.string,
  icon: r.string,
  iconClass: r.string,
  imageUrl: r.string,
  disabled: r.bool,
  render: r.any
};
let e = s;
export {
  e as SplitButtonItem
};
